import React from 'react';

const SIZES = {
  xs: 'w-7 h-7 text-sm',
  sm: 'w-9 h-9 text-base',
  md: 'w-11 h-11 text-lg',
  lg: 'w-14 h-14 text-2xl',
};

const PlayerAvatar = ({ user, size = 'sm', className = '' }) => {
  const sizeClass = SIZES[size] || SIZES.sm;
  const photo = user?.photo || '👤';
  const photoURL = user?.photoURL;

  if (photoURL) {
    return (
      <div className={`relative ${className}`}>
        <img src={photoURL} alt="" className={`${sizeClass} rounded-full object-cover`} />
        {photo && <span className="absolute -bottom-0.5 -right-0.5 text-xs bg-white rounded-full shadow-sm border border-slate-100 w-4 h-4 flex items-center justify-center text-[10px]">{photo}</span>}
      </div>
    );
  }

  return (
    <div className={`${sizeClass} rounded-full bg-slate-100 flex items-center justify-center shadow-inner ${className}`}>
      {photo}
    </div>
  );
};

export default PlayerAvatar;
